import { api } from "../lib/api";

export interface UploadedFile {
	url: string;
	success: boolean;
}

/**
 * Upload a file to Vercel Blob storage
 * @param file The file to upload
 * @returns Promise with the uploaded file URL
 */
export async function uploadFileToBlob(file: File): Promise<string> {
	const formData = new FormData();
	formData.append("file", file);

	const response = await api.post<UploadedFile>(
		"/api/upload/chat-file",
		formData,
		{
			headers: {
				"Content-Type": "multipart/form-data",
			},
		},
	);

	if (!response.data.success) {
		throw new Error("File upload failed");
	}

	return response.data.url;
}

/**
 * Upload multiple files to Vercel Blob storage
 * @param files Array of file/dataUrl pairs
 * @returns Promise with array of uploaded file URLs
 */
export async function uploadFilesToBlob(
	files: Array<{ file: File; dataUrl: string }>,
): Promise<
	Array<{
		type: "file";
		url: string;
		mediaType: string;
	}>
> {
	const uploadedFiles: Array<{
		type: "file";
		url: string;
		mediaType: string;
	}> = [];

	for (const { file } of files) {
		try {
			const url = await uploadFileToBlob(file);
			uploadedFiles.push({
				type: "file",
				url,
				mediaType: file.type,
			});
		} catch (error) {
			console.error("Error uploading file:", error);
			// Continue with other files
		}
	}

	return uploadedFiles;
}
